import React from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * Skeleton for card grid layouts (e.g. MesRendezVous, dashboard cards).
 * @param {number} columns - Number of columns
 * @param {number} rows - Number of card rows per column
 */
export function CardGridSkeleton({ columns = 3, rows = 2 }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: 2,
        width: '100%',
        maxWidth: 1100,
        mx: 'auto',
      }}
    >
      {Array.from({ length: columns }).map((_, colIndex) => (
        <Box key={colIndex} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <Skeleton
              key={rowIndex}
              variant="rounded"
              height={120}
              sx={{ borderRadius: 2 }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
}
